<template>
  <div>
    <a-button
      v-ripple
      @click="show"
      type="primary"
      :title="title"
    >
      <i class="mdi mdi-plus increased" />
    </a-button>
    <a-drawer
      :width="700"
      :title="'feature-flags.title' | globalize"
      placement="right"
      :visible="visible"
      :footer-style="{ textAlign: 'right' }"
      @close="onCancel"
    >
      <a-form
        :form="form"
        layout="horizontal"
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'feature-flags.lbl-flag' | globalize"
        >
          <a-input
            :placeholder="'feature-flags.lbl-flag' | globalize"
            :disabled="loading"
            v-decorator="decorators.flag"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'feature-flags.lbl-description' | globalize"
        >
          <a-input
            :placeholder="'feature-flags.lbl-description' | globalize"
            :disabled="loading"
            v-decorator="decorators.description"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="'feature-flags.lbl-status' | globalize"
        >
          <a-switch
            :disabled="loading"
            v-decorator="decorators.status"
          />
          {{
            (form.getFieldValue('status') ?
              'feature-flags.status-enabled' : 'feature-flags.status-disabled') |
              globalize
          }}
        </a-form-item>
        <a-divider />

        <template v-if="errorMessage">
          <a-alert
            type="error"
            :message="errorMessage" />
        </template>
        <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
          <a-button
            style="margin-right: 8px"
            :loading="loading"
            @click="onCancel">
            {{ 'feature-flags.cancel' | globalize }}
          </a-button>
          <a-button
            type="primary"
            :loading="loading"
            @click="onSubmit">
            {{ 'feature-flags.add' | globalize }}
          </a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import AForm from 'ant-design-vue/lib/form'
import AInput from 'ant-design-vue/lib/input'
import ADivider from 'ant-design-vue/lib/divider'
import AButton from 'ant-design-vue/lib/button'
import ADrawer from 'ant-design-vue/lib/drawer'
import AAlert from 'ant-design-vue/lib/alert'
import ASwitch from 'ant-design-vue/lib/switch'
import { globalize } from '@/vue/filters/globalize'
import { Bus } from '@/js/helpers/event-bus'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
const formTailLayout = {
  labelCol: { span: 16 },
  wrapperCol: { span: 16, offset: 16 },
}

export default {
  name: 'feature-flags-editor',
  components: {
    AForm,
    AInput,
    ADivider,
    ASwitch,
    AFormItem: AForm.Item,
    AButton,
    ADrawer,
    AAlert,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    mode: {
      type: String,
      default: 'new',
    },
    details: {
      type: Object,
      default: () => {},
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      visible: false,
      formItemLayout,
      formTailLayout,
      errorMessage: '',
      form: this.$form.createForm(this, {
        name: 'feature-flags-editor',
      }),
      decorators: {
        flag: [
          'flag',
          { rules: [
            { required: true, message: globalize('validation.field-error_required') },
          ],
          },
        ],
        description: ['description'],
        status: [
          'status',
          {
            initialValue: false,
          },
        ],
      },
    }
  },
  created () {
    Bus.on('feature-flags-list-updated', this.onCancel)
  },
  destroyed () {
    Bus.resetEvent('feature-flags-list-updated')
  },
  methods: {
    onSubmit () {
      this.form.validateFields((err, values) => {
        if (err) return
        this.$emit('add', values)
      })
    },
    onCancel () {
      this.visible = false
    },
    show () {
      this.form.resetFields()
      this.visible = !this.visible
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/alert/style/index.css';
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/input/style/index.css';
  @import '~ant-design-vue/lib/divider/style/index.css';
  @import '~ant-design-vue/lib/form/style/index.css';
  @import '~ant-design-vue/lib/drawer/style/index.css';
  @import '~ant-design-vue/lib/switch/style/index.css';
</style>
